import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {ellipsis} from 'ag-common/tools/string'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Avatar from '#components/a/Avatar'
import StatusuebersichtIcon from '#components/svg/icons/NavStatusUebersicht'
import StyledText from '#components/a/StyledText'
import {routeHelper} from '#config/routeKeys'

export class AufgabeAbschliessenBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick, senderId} = this.props
    onNotificationClick(routeHelper.praxisaufgabenDetail(senderId))
  }

  render() {
    const {userInfo, abteilungName, text} = this.props
    const textString = i18n.t('notification_text_aufgabe_erledigt', [
      `${userInfo.lastname}, ${userInfo.firstname}`,
      abteilungName,
      ellipsis(text, 20),
    ])

    return (
      <div
        role="button"
        tabIndex={0}
        className="notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <Avatar profileImage={userInfo.profileImage} />
        <StyledText text={textString} modifier="notification" />
        <div className="notification__icon notification__icon--right">
          <StatusuebersichtIcon />
        </div>
      </div>
    )
  }
}

AufgabeAbschliessenBenachrichtigung.propTypes = {
  senderId: PropTypes.number,
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  abteilungName: PropTypes.string,
  text: PropTypes.string,
  onNotificationClick: PropTypes.func,
}

export default UserInfoHOC(AufgabeAbschliessenBenachrichtigung, ['senderId'])
